// When the content is loaded, open the accordion matched by the URL hash
function openHashAccordion() {
  if (!window.location.hash) {
    return;
  }

  // id must be valid (not start with a number)
  if (!/#[a-z]/.test(window.location.hash)) {
    return;
  }

  const activeEl = document.querySelector(window.location.hash);
  if (activeEl?.classList.contains("accordion__item")) {
    activeEl.open = true;
  }
}

const getClosingHeight = function ($openEl) {
  const name = $openEl.getAttribute("name");

  let height = 0;
  const $allDetails = document.querySelectorAll(`details[name=${name}]`);
  for (const $item of $allDetails) {
    if ($item === $openEl) {
      // We only consider elements above the one we're opening, the ones
      // below won't affect scroll, exit the loop
      break;
    }
    if (!$item.open) {
      continue;
    }
    height += $item.querySelector(".accordion__body").offsetHeight;
  }

  return height;
};

// Opening exclusive accordions may close other accordions on the page. If
// they are close enough to our opened accordion, their disappearance may
// cause the page to "scroll" (readjust) up or down. This function
// artificially scrolls the page to make it seamless.
function fixScrollAndMaybePolyfillExclusiveAccordions() {
  const scroller = document.querySelector(".app-page__content");

  // We can't use the toggle event because when exclusive accordions are
  // native, the open accordions are closed in the same tick, rendering
  // impossible to compute their height
  scroller?.addEventListener("click", (event) => {
    const $openEl = event.target.closest(".accordion__item[name]:not([open])");
    if (!$openEl) return;

    const closingHeight = getClosingHeight($openEl);

    // Firefox doesn't support [name] attribute on accordions until 130 is
    // released (sept 2024), so we need to polyfill this behaviour.
    //
    // TODO: remove end of 2024
    //
    // https://developer.chrome.com/docs/css-ui/exclusive-accordion
    let diff = 0;
    if (navigator.userAgent.indexOf("Firefox") !== -1) {
      // Normally scrollTop doesn't change when opening an accordion, but it
      // does when the accordion is close to the top or bottom of the page. We
      // need to account for this difference when scrolling back to the
      // original position, at least for Firefox, to prevent a visual glitch
      //
      // TODO: this can probably be removed when the polyfill is removed, but
      // double check that the glitch is gone with the official implementation
      const before = scroller.scrollTop;

      const name = $openEl.getAttribute("name");
      document.querySelectorAll(`details[name=${name}][open]`).forEach(($openDetails) => {
        if (!($openDetails === $openEl)) {
          $openDetails.open = false;
        }
      });

      diff = scroller.scrollTop - before;
    }

    scroller.style.scrollBehavior = "auto";
    scroller.scrollBy(0, -(closingHeight + diff));
    scroller.style.scrollBehavior = null;
  });
}

document.addEventListener("DOMContentLoaded", (_event) => {
  openHashAccordion();
  fixScrollAndMaybePolyfillExclusiveAccordions();
});
